var _desc, _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Heart",
    width: 32,
    height: 32,
    fill: "currentColor",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 11.5C3.5 9.99 4.02 8.54 4.97 7.37C5.92 6.21 7.25 5.42 8.72 5.12C10.19 4.83 11.72 5.05 13.05 5.76C14.38 6.46 15.42 7.61 16 9C16.57 7.61 17.61 6.46 18.94 5.76C20.27 5.05 21.8 4.83 23.27 5.12C24.74 5.42 26.07 6.21 27.02 7.37C27.97 8.54 28.5 9.99 28.5 11.5C28.5 20 16 27 16 27C16 27 3.5 20 3.5 11.5Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.4c82331aa28b05d872882db89ea7c9d4.svg";
export { ForwardRef as ReactComponent };